class HeaderNavigation {
  constructor() {
    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    const container = document.querySelector('[data-header-navigation]');
    const toggles = document.querySelectorAll('.header-navigation__submenu-toggle');

    if (container && toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          toggle.closest('.header-navigation__list-item').classList.toggle('header-navigation__list-item--submenu-visible');
        });
      });
    }
  }
}

export default new HeaderNavigation();
